import styled from 'styled-components';

export const PmeDashboardStyle = styled.div`
  display: flex;
  background: white;
  flex-direction: column;
  justify-content: flex-start;
  padding: 15px 15px 0px;
  margin-bottom: 20px;

  .clear-filters {
    display: flex;
    cursor: pointer;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;

      .clear-filters-span {
        margin-left: 6px;
        margin-right: 12px;
        color: var(--mmt-primary-70);
        text-decoration: underline;
        font-size: 13px;
      }

      .close-icon {
        font-size: 10px;
        color: var(--mmt-primary-70);
      }
    }
  }

  .dashboard-header {
    display: flex;

    .cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
    
      label {
        margin-bottom: 0px;
        margin-right: 12px;
      }
    }

    .blue-title {
      font-size: var(--size-lg);
      font-family: SF UI Display;
      font-weight: 600;
      line-height: 22px;
      color: var(--mmt-primary-70);
    }

    .main {
      flex: 1
    }
  }
  
  .ant-divider-horizontal.ant-divider-with-text-left::after {
    top: 0%;
  }

  .ant-divider {
    font-size: 18px;
    font-weight: 600;
		font-family: SF UI Display;
    line-height: 22px;
    color: #595959;
    position: relative;
    
    &::before {
      display: none;
    }
    
    span {
      padding-left: 0;
    }
    
    &::after {
      border-top: 1px solid #D1D1D1;
    }
  }

  section {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin: var(--size-lg) 0 0 0;
    width: 100%;
    height: 100%;
    
    .sider {
      width: 35%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      > div:not(:last-of-type) {
        margin-bottom: 20px;
      }

      &.width-350 {
        width: 350px;
      }
    }

    .main {
      width: -webkit-fill-available;
      height: unset;
      display: flex;

      > div:last-of-type {
        margin-left: 20px;
      }
    }
  }

  .multi-section {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    .section-col {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 100px;

      .main {
        gap: 20px;

        > div:last-of-type {
          margin-left: 0px;
        }
      }
    }
  }

  .divider-with-btn {
    display: flex;

    .main-container {
      flex: 1;
    }
  }

  .ellipsis-span {
    width: 100%;
  }

  .name-span {
    text-decoration: underline;
  }

  .text-light-blue {
    color: var(--mmt-primary-70);
  }
`;